/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/App/Menu.ts" />
namespace HA.Core.Controller.HTML {
    import MenuTag = HA.Core.HTML.App.Menu;

    export class AppMenu extends Controller {

        public clear() {
            this.getTag().clear();
        }

        public addItem(data: Map<string, any>) {
            this.getTag().addItem(data);
        }

        protected createTag(data: any) {
            this.addToData("tag", new MenuTag(data));
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.createTag(data);
        }

    }

    interface IService {
        toggleApp: (d: any) => void;
        showApp: (d: any) => void;
        reloadApp: (d: any) => void;
        showAppMenu: (d: any) => void;
    }
}
